export const searchObjectByKey = (
  targetObject: any,
  targetKey: any,
  operation: any,
) => {
  let recursiveObject: any;
  if (!targetObject) {
    return;
  }

  Object.keys(targetObject).forEach((currentKey: any) => {
    if (currentKey === targetKey) {
      recursiveObject = targetObject[currentKey];
      targetObject[currentKey] = operation(recursiveObject);
    }
    if (typeof targetObject[currentKey] === 'object') {
      recursiveObject = searchObjectByKey(
        targetObject[currentKey],
        targetKey,
        operation,
      );
      return;
    }
  });
  return recursiveObject;
};
